import React from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import * as S from './styles'

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	}
}

export function SubHeader({ theme, stepState, setStepState }) {
	return (<S.Section bgColor={theme.palette.white}>
		<S.Container maxWidth={theme.config.containerWidth}>
			<S.Title>Simulador de independência financeira (aposentadoria)</S.Title>
			<Tabs scrollButtons="auto" variant="scrollable" indicatorColor="primary" textColor="primary" value={stepState.index} onChange={(e, n) => {
				setStepState({
					...stepState,
					index: n,
				})
			}} aria-label="simple tabs example">
				<Tab label="QUAL SEU OBJETIVO?"  {...a11yProps(0)} />
				<Tab label="PLANO DE INDEPENDÊNCIA FINANCEIRA" disabled={stepState.enable < 1} {...a11yProps(1)} />
				<Tab label="RESULTADO" {...a11yProps(2)} disabled={stepState.enable < 2}/>
			</Tabs>
		</S.Container>
	</S.Section>)
}
